/**
 * Rights mode.
 * @internal
 */
export enum MKRightsMode {
    /**
     * Live.
     */
    Live = "LIVE",

    /**
     * VOD.
     */
    VOD = "VOD_STREAMING"
}